import { render, staticRenderFns } from "./tipoDocumentoList.vue?vue&type=template&id=01970934"
import script from "./tipoDocumentoList.vue?vue&type=script&lang=js"
export * from "./tipoDocumentoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports